export const COUNTRIES = [
  'Tüm Ülkeler',
  'Türkiye',
  'ABD',
  'Almanya',
  'Fransa',
  'İngiltere',
  'İspanya',
  'İtalya',
  'Kanada',
  'Avustralya',
  'Japonya',
  'Güney Kore',
  'Brezilya',
  'Meksika',
  'Hindistan',
  'Arjantin',
  'Şili',
  'Kolombiya',
  'Peru',
  'Venezuela',
  'Rusya',
  'Çin',
  'Endonezya',
  'Filipinler',
  'Tayland',
  'Vietnam',
  'Malezya',
  'Singapur',
  'Yeni Zelanda',
  'Güney Afrika',
  'Mısır',
  'Nijerya',
  'Kenya',
  'Polonya',
  'Hollanda',
  'Belçika',
  'İsviçre',
  'Avusturya',
  'İsveç',
  'Norveç',
  'Danimarka',
  'Finlandiya',
  'Portekiz',
  'Yunanistan',
  'Çek Cumhuriyeti',
  'Macaristan',
  'Romanya',
  'Bulgaristan',
  'Ukrayna',
  'Suudi Arabistan',
  'Birleşik Arap Emirlikleri',
  'İsrail',
  'Pakistan',
  'Bangladesh',
  'Sri Lanka',
] as const;

const COUNTRY_CODE_MAP: Record<string, string> = {
  Türkiye: 'TR',
  ABD: 'US',
  Almanya: 'DE',
  Fransa: 'FR',
  İngiltere: 'EN',
  İspanya: 'ES',
  İtalya: 'IT',
  Kanada: 'CA',
  Avustralya: 'AU',
  Japonya: 'JP',
  'Güney Kore': 'KR',
  Brezilya: 'BR',
  Meksika: 'MX',
  Hindistan: 'IN',
  Arjantin: 'AR',
  Şili: 'CL',
  Kolombiya: 'CO',
  Peru: 'PE',
  Venezuela: 'VE',
  Rusya: 'RU',
  Çin: 'CN',
  Endonezya: 'ID',
  Filipinler: 'PH',
  Tayland: 'TH',
  Vietnam: 'VN',
  Malezya: 'MY',
  Singapur: 'SG',
  'Yeni Zelanda': 'NZ',
  'Güney Afrika': 'ZA',
  Mısır: 'EG',
  Nijerya: 'NG',
  Kenya: 'KE',
  Polonya: 'PL',
  Hollanda: 'NL',
  Belçika: 'BE',
  İsviçre: 'CH',
  Avusturya: 'AT',
  İsveç: 'SE',
  Norveç: 'NO',
  Danimarka: 'DK',
  Finlandiya: 'FI',
  Portekiz: 'PT',
  Yunanistan: 'GR',
  'Çek Cumhuriyeti': 'CZ',
  Macaristan: 'HU',
  Romanya: 'RO',
  Bulgaristan: 'BG',
  Ukrayna: 'UA',
  'Suudi Arabistan': 'SA',
  'Birleşik Arap Emirlikleri': 'AE',
  İsrail: 'IL',
  Pakistan: 'PK',
  Bangladesh: 'BD',
  'Sri Lanka': 'LK',
};

export function getCountryCode(countryName: string): string | null {
  if (countryName === 'Tüm Ülkeler') return null;
  return COUNTRY_CODE_MAP[countryName] ?? null;
}
